export const iconFontAwesomeFoodBeverageJar = (
	<i className="fa-solid fa-jar"></i>
);
